import { LocalStorageLoader } from "@alme/storage-ts/LocalStorageLoader";
import SFDDLObject from "../data/_SFDDL/eservice.json";
import PSCCNavResponseObject from "../data/PSCCNavResponse.json";
import PlatformInformationObject from "../data/PlatformInformation.json";
const savedTestPageState = new LocalStorageLoader('almeUiTestPageState');
export function updateTestPageState(state) {
    try {
        savedTestPageState.UpdateStorage(state);
    }
    catch (ex) {
        console.error(ex);
    }
}
export function getTestPageState() {
    let testPageState = null;
    try {
        testPageState = savedTestPageState.GetStorage();
    }
    catch (ex) {
        console.error(ex);
    }
    return testPageState;
}
export const defaultTestPageState = {
    loginParams: {
        clientSessionId: '1234',
        userMetadata: {
            accountNumber: '1234',
            emailId: 'Sydney@Synchrony.com',
            primaryName: 'Sydney AwesomeIva',
            zipCode: '99216',
            accountType: 'Generic',
            currentEnterpriseId: "17d943aa-3be7-4598-b5b0-9cbea5b2979a",
            platformInformation: PlatformInformationObject,
        },
    },
    launchSettings: {
        launchPointName: 'Global',
        launchParameter: 'Main',
    },
    SFDDL: JSON.stringify(SFDDLObject),
    PSCCNavResponse: JSON.stringify(PSCCNavResponseObject),
    enableVistaUI: {
        checked: false,
    },
    enablePeaksUI: {
        checked: false,
    },
};
